<div class="mat-modal-dialog session-expiry-modal">
  <mat-icon style="color:red; float: right; cursor: pointer; position: relative; top: 5px; font-size: 20px; z-index: 1;"
    (click)="onClose()">close</mat-icon>
  <h2 mat-dialog-title>
    <span class="material-icons-outlined warning-icon">info</span>
    <span class="dialog-title-text">Session expiring soon</span>
  </h2>

  <mat-dialog-content>
    <p class="session-expiry-message">
      Your session will expire in approximately <strong>{{ remainingMinutes }}</strong>
      minute{{ remainingMinutes === 1 ? '' : 's' }}.
      Click Continue Session to stay logged in and avoid losing unsaved work.
    </p>
  </mat-dialog-content>

  <div mat-dialog-actions align="end">
    <!-- <button type="button" class="btn footerBtn session-confirms-btn" (click)="onSignInNow()">
      Sign In Again
    </button> -->
    <button type="button" class="btn footerBtn session-confirms-btn" (click)="continueSession()">
      Continue
    </button>
  </div>
</div>